import {Component, OnInit} from '@angular/core';
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {UsersService} from './../users.service';
import {UserModel} from './../../../models/user/users.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import {SidebarService} from '../../../shared/services/sidebar.service';
import { ClientEnum, ClientModel } from '../../../models/survey/survey.model';
import { SELECT_TEXT } from '../../../shared/constants/input.constants';
import { Role } from '../../../enums/role.enum';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.less']
})
export class NewUserComponent implements OnInit {

  positions: string[];
  dropdownLabel: string;
  patternPassword = /^\S*$/;
  user: UserModel;
  userForm: FormGroup;
  password: boolean;
  changePassError: boolean;
  isAdmin: boolean;
  isCustomerAdmin: boolean;
  clients: ClientModel[];
  currentClient: string;
  currentUser = AuthTokenService.getUser();
  uniqueEmailError: boolean;
  uniqueNameError: boolean;
  isCurrentUser: boolean;
  constructor(protected usersService: UsersService,
              protected fb: FormBuilder,
              protected sidebarService: SidebarService,
              protected router: Router,
              protected route: ActivatedRoute) {

    this.route.data.subscribe(data => {
        this.clients = data.clients;
    });

    this.userForm = this.fb.group({
      'firstName': [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      'lastName': [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      'email': [null, Validators.compose([Validators.required, Validators.maxLength(50), CustomValidators.email])],
      'position': [null, Validators.compose([Validators.required, Validators.maxLength(20)])],
      'password': [null, Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(4), Validators.pattern(this.patternPassword)])],
      'confirmPassword': [null]
    });
  }

  ngOnInit() {
    this.dropdownLabel = SELECT_TEXT;
    this.positions = [];
    this.user = new UserModel();
    this.password = true;
    this.changePassError = false;
    this.uniqueEmailError = false;
    this.uniqueNameError = false;
    this.isCurrentUser = false;
    this.usersService.addNewUser().subscribe(
      (response) => {
        this.user = response;
        this.user.dateCreated = null;
        this.user.password = '';
        this.user.confirmPassword = '';
        this.user.active = true;
        if (this.isCustomerAdmin) {
            this.user.clientId = this.currentUser.clientId;
            const client = this.clients.find(item => {
                return item.id == this.user.clientId;
            });
            if (client !== undefined) {
                this.currentClient = client.name;
                for (let i = 0; i < this.user.listEnumRoles.length; i++) {
                    if (this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.CUSTOMER_ADMIN.toLocaleLowerCase() || this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.CUSTOMER_USER.toLocaleLowerCase()) {
                        this.positions.push(this.user.listEnumRoles[i].name);
                    }
                }
            }
        }
      },
      _ => {
      }
    );
    this.isAdmin = AuthTokenService.isAdmin();
    this.isCustomerAdmin = AuthTokenService.isCustomerAdmin();
    this.currentClient = SELECT_TEXT;
  }

  saveUser() {
    if (this.password) {
      if (this.user.password != null && this.user.password !== this.user.confirmPassword) {
        this.changePassError = true;
        return false;
      }
    } else {
      this.changePassError = false;
      this.user.password = null;
    }
    this.usersService.save(this.user).subscribe(
      (response) => {
        if (this.sidebarService.menuData) {
          this.sidebarService.menuData.totalUsers++;
        }
        this.router.navigate(['users']);
      },
      (error) => {
        // console.log(error);
      }
    );
  }

  changeRole(e) {
    const role = this.user.listEnumRoles.find(item => {
        return item.name == e;
    });
    if (role !== undefined) {
        this.user.role = role.id;
        this.dropdownLabel = role.name;
    }
  }

  changePassword() {
    this.password = true;
  }

  onUserActiveChange(e) {
    this.user.active = e.srcElement.checked;
  }

  setClient(e): void {
    const client = this.clients.find(item => {
        return item.id == e.id;
    });
    if (client !== undefined) {
        this.user.clientId = client.id;

        this.positions = [];
        this.dropdownLabel = SELECT_TEXT;
        this.user.role = null;
        if (client.name === ClientEnum.INTERNAL) {
            for (let i = 0; i < this.user.listEnumRoles.length; i++) {
                if (this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.ADMIN.toLocaleLowerCase() || this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.USER.toLocaleLowerCase()) {
                    this.positions.push(this.user.listEnumRoles[i].name);
                }
            }
        } else {
            for (let i = 0; i < this.user.listEnumRoles.length; i++) {
                if (this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.CUSTOMER_ADMIN.toLocaleLowerCase() || this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.CUSTOMER_USER.toLocaleLowerCase()) {
                    this.positions.push(this.user.listEnumRoles[i].name);
                }
            }
        }
    }
  }

  checkIfPasswordsMatch() {
    if (this.password) {
      if (this.user.password !== this.user.confirmPassword) {
        this.changePassError = true;
      } else {
        this.changePassError = false;
      }
    }
  }

  checkIfEmailUnique() {
    this.uniqueEmailError = false;
    if (!this.userForm.controls['email'].hasError('email') || (!this.userForm.controls['email'].dirty && !this.userForm.controls['email'].touched)) {
      if (this.user.email && this.user.email.trim() !== '') {
        let user = new UserModel();
        user.id = this.user.id;
        user.email = this.user.email;
        this.usersService.isExistingUser(user).subscribe(
          (isExist) => {
            this.uniqueEmailError = isExist;
          },
          (_) => {}
        );
      }
    }
  }

  checkIfNameUnique() {
    if (this.user.firstName !== '' && this.user.lastName !== '' && this.user.clientId) {
      let user = new UserModel();
      user.id = this.user.id;
      user.firstName = this.user.firstName;
      user.lastName = this.user.lastName;
      user.clientId = this.user.clientId;
      this.usersService.isExistingUser(user).subscribe(
        (isExist) => {
          this.uniqueNameError = isExist;
        },
        (_) => {}
      );
    }
  }

  isUserRole(user: UserModel) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/users/new-user/new-user.component.ts